<app-split-pane
  storageKey="split.quality"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.quality.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="qualitySuggestions" [context]="qualityContext" placeholder="Ask about quality metrics..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="quality.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.quality.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Quality</h2>
            <p class="text-muted mb-3">
              Set release quality gates and evaluate if the current baseline is acceptable.
            </p>
            <h3 class="h5 mb-3">Quality Gate Configuration</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Minimum coverage (%)</label>
                <input class="form-control" type="number" min="1" max="100" [(ngModel)]="qualityGateDraft.minimumCoverage" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Max critical lint issues</label>
                <input class="form-control" type="number" min="0" [(ngModel)]="qualityGateDraft.maxCriticalLint" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Minimum test pass rate (%)</label>
                <input class="form-control" type="number" min="1" max="100" [(ngModel)]="qualityGateDraft.minTestPassRate" />
              </div>
              <div class="col-12">
                <label class="form-label">Gate notes</label>
                <textarea class="form-control" rows="3" [(ngModel)]="qualityGateDraft.gateNotes" placeholder="Owner, exceptions, and timelines..."></textarea>
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="evaluatingGate" (click)="evaluateQualityGate()">
                @if (evaluatingGate) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Evaluating...
                } @else {
                  Evaluate Quality Gate
                }
              </button>
            </div>
            @if (qualityError) {
              <div class="alert alert-danger mt-3 mb-0">{{ qualityError }}</div>
            }
            @if (qualitySuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ qualitySuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Gate Summary</h3>
            @if (!hasEvaluatedGate) {
              <div class="small text-muted">No evaluation yet. Evaluate quality gate to populate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Coverage</div>
                  <div class="summary-value">{{ qualityGateDraft.minimumCoverage }}%</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Critical lint max</div>
                  <div class="summary-value">{{ qualityGateDraft.maxCriticalLint }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Pass-rate target</div>
                  <div class="summary-value">{{ qualityGateDraft.minTestPassRate }}%</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Notes</div>
                  <div class="summary-value">{{ qualityGateDraft.gateNotes.trim() || 'No notes provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="quality.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
